{
  "contactModal": {
    "delete": {
      "cancel": "Cancelar",
      "confirm": "Excluir",
      "error": {
        "contactWithInformationRequests": "contactWithInformationRequests",
        "default": "default",
        "title": "title"
      },
      "message": "Tem certeza de que deseja excluir este contato?",
      "success": "success",
      "title": "Excluir contato"
    }
  },
  "contacts": {
    "buttons": {
      "add": "Adicionar um contato"
    },
    "table": {
      "headers": {
        "actions": "Ações",
        "email": "E-mail",
        "id": "ID",
        "name": "Nome"
      }
    }
  },
  "productionSiteModal": {
    "actions": {
      "cancel": "Cancelar",
      "delete": "Excluir",
      "save": "Guardar"
    },
    "createTitle": "Novo local de produção",
    "delete": {
      "cancel": "Cancelar",
      "confirm": "Excluir",
      "message": "Tem certeza de que deseja excluir este local de produção?",
      "title": "Excluir local de produção"
    },
    "editTitle": "Editar um local de produção",
    "errors": {
      "cityRequired": "A cidade é obrigatória",
      "coordinatesMaxDecimals": "Latitude e longitude podem ter no maximo 6 casas decimais",
      "countryMustBeValid": "País deve ser válido (ex. FR, DE)",
      "internalCodeTooLong": "O código interno deve ter menos de 32 caracteres",
      "nameRequired": "Nome é obrigatório",
      "parentCompanyRequired": "parentCompanyRequired",
      "postalCodeTooShort": "O código postal deve ter pelo menos 3 caracteres",
      "streetRequired": "A rua é obrigatória",
      "streetTooShort": "A rua deve ter pelo menos 3 caracteres"
    },
    "labels": {
      "city": "Cidade do local de produção",
      "country": "País",
      "internalCode": "Código interno",
      "latitude": "Latitude do local de produção",
      "longitude": "Longitude do local de produção",
      "name": "Nome do local de produção",
      "parentCompany": "Empresa madre",
      "performedActivities": "Atividades realizadas",
      "postalCode": "Código postal do local de produção",
      "registrationId": "IDs de registo do site",
      "street": "Rua do local de produção"
    },
    "placeholders": {
      "city": "Cidade do local de produção",
      "country": "Selecione o país do site",
      "internalCode": "ex. BD-DAK-001 ou sua referência interna",
      "latitude": "Latitude do local de produção",
      "longitude": "Longitude do local de produção",
      "name": "ex. Unidade Corte e Costura Dhaka A",
      "performedActivities": "ex. Corte, costura, acabamento, tingimento",
      "postalCode": "Código postal do local de produção",
      "registrationId": "ex. NIF, CIN, GSTIN, USC",
      "street": "Rua do local de produção"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS: 9 dígitos.",
      "EORI": "EORI: código país + 14 dígitos.",
      "GLN": "GLN: 13 dígitos.",
      "OTHER": "Outro: máx. 32 caracteres.",
      "RCS": "RCS: RCS + espaço + nome empresa + espaço + [A,B] + espaço + 9 dígitos.",
      "VAT": "VAT: código país (ex. FR) + 2 dígitos + 9 dígitos SIREN."
    },
    "registrationIdErrors": {
      "DUNS": "O ID de registo DUNS deve ser um número de 9 dígitos.",
      "EORI": "O ID de registo EORI deve estar no formato: código país (ex. FR) + 14 dígitos.",
      "GLN": "O ID de registo GLN deve ser um número de 13 dígitos.",
      "OTHER": "O ID de registo outro deve ter menos de 32 caracteres.",
      "RCS": "O ID de registo RCS deve estar no formato: RCS + espaço + nome empresa + espaço + [A,B] + espaço + 9 dígitos.",
      "VAT": "O ID de registo VAT deve estar no formato: código país (ex. FR) + chave 2 dígitos + número SIREN 9 dígitos."
    },
    "tabs": {
      "generalInfo": "Informações gerais",
      "location": "Localização"
    },
    "tooltips": {
      "address": "Endereço do local de produção",
      "city": "Cidade do local de produção",
      "country": "País do local de produção",
      "internalCode": "Código interno do local de produção",
      "latitude": "Latitude do local de produção",
      "longitude": "Longitude do local de produção",
      "name": "Nome do local de produção",
      "parentCompany": "parentCompany",
      "performedActivities": "Atividades realizadas no local de produção",
      "postalCode": "Código postal do local de produção",
      "registrationId": "IDs de registo do local de produção",
      "street": "Rua do local de produção"
    }
  },
  "productionSites": {
    "buttons": {
      "add": "Adicionar um local de produção"
    },
    "create": {
      "error": "Erro ao criar o local de produção",
      "success": {
        "message": "Local de produção criado com sucesso",
        "title": "Local de produção criado"
      }
    },
    "delete": {
      "error": "Erro ao excluir o local de produção",
      "success": {
        "message": "Local de produção excluído com sucesso",
        "title": "Local de produção excluído"
      }
    },
    "filters": {
      "country": "País",
      "internalCode": "Código interno",
      "isConfidential": "Confidencial",
      "isConfidentialFalse": "Não",
      "isConfidentialTrue": "Sim",
      "name": "Nome do local de produção",
      "nothingFoundMessage": "nothingFoundMessage",
      "performedActivities": "Atividades realizadas no local de produção",
      "searchPlaceholder": "Buscar filtros",
      "title": "Filtros"
    },
    "search": {
      "placeholder": "Buscar por nome ou endereço"
    },
    "sorts": {
      "address": "Endereço",
      "country": "País",
      "email": "Email",
      "internalCode": "Código interno",
      "name": "Nome"
    },
    "table": {
      "headers": {
        "address": "Endereço",
        "certificates": "Certificados",
        "deleted": "Excluído",
        "id": "ID",
        "internalCode": "Código interno",
        "name": "Nome do local de produção",
        "parentCompany": "parentCompany",
        "performedActivities": "Atividades realizadas",
        "registrationId": "IDs de registo do site"
      }
    },
    "title": "Locais de Produção",
    "update": {
      "error": "Erro ao atualizar o local de produção",
      "success": {
        "message": "Local de produção atualizado com sucesso",
        "title": "Local de produção atualizado"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Erro"
    }
  }
}
